var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3077 0H2.07694C0.931687 0 0 0.931687 0 2.07694V21.9231C0 23.0683 0.931687 24 2.07694 24H17.3077C17.6901 24 18 23.69 18 23.3077V0.692297C18 0.309984 17.69 0 17.3077 0ZM3.46153 3H14.5385C14.9208 3 15.2308 3.30998 15.2308 3.6923C15.2308 4.07461 14.9208 4.38459 14.5385 4.38459H3.46153C3.07917 4.38459 2.76923 4.07461 2.76923 3.6923C2.76923 3.30998 3.07922 3 3.46153 3ZM3.46153 6.6923H9.02306C9.40542 6.6923 9.71536 7.00228 9.71536 7.38459C9.71536 7.76691 9.40538 8.07689 9.02306 8.07689H3.46153C3.07917 8.07689 2.76923 7.76691 2.76923 7.38459C2.76923 7.00228 3.07922 6.6923 3.46153 6.6923ZM16.6154 22.6154H2.07694C1.69519 22.6154 1.38464 22.3049 1.38464 21.9231V21H16.6154V22.6154Z",
    fill: "#7BC6B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.9740d9f00c63199b077cd3394c8485e8.svg";
export { ForwardRef as ReactComponent };